/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/420-flickr': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 8.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm9 0a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"/>'
  }
})
